import { render } from "./IndexCheck.vue?vue&type=template&id=94596b94"
import script from "./IndexCheck.vue?vue&type=script&lang=js"
export * from "./IndexCheck.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__